import { PROJECTS } from '@/router/route-types';

const Empty = {
  template: `<router-view />`
};

export default {
  path: 'projects',
  component: Empty,
  meta: { auth: true },
  children: [
    {
      path: '',
      name: PROJECTS,
      component: () => import(/* webpackChunkName: "projects" */ '@/views/Projects/Projects.vue'),
      meta: {
        auth: true,
        role: 'admin'
      }
    }
    // {
    //     path: ':id',
    //     name: 'project',
    //     component: () => import(/* webpackChunkName: "project" */ '@/views/Personalize/Personalize.vue'),
    //     meta: { auth: true }
    // }
  ]
};
